<template>
  <nav class="nav_center2" style="padding: 0; background: cadetblue">
    <ul style="list-style: none">
      <li :class="{ topmenuactive: activeTab === 'hethongcntthanoi' }" @click="changeTab('hethongcntthanoi')">
        <a id="urlhethongcntthanoi" href="vi/chuongtrinhtaitroxathidiem#hanoi/hethongcntthanoi" style="color: white;">{{ currentLanguage.header_text_hethongCNTT15 }}</a>
      </li>
  <li :class="{ topmenuactive: activeTab === 'Xathachthat' }" @click="changeTab('Xathachthat')">
  <a id="urlXathachthat" href="vi/chuongtrinhtaitroxathidiem#hanoi/xathachthat" style="color: white;">
    {{ currentLanguage.header_text_ThachThat }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xaphuctho' }" @click="changeTab('Xaphuctho')">
  <a id="urlXaphuctho" href="vi/chuongtrinhtaitroxathidiem#hanoi/xaphuctho" style="color: white;">
    {{ currentLanguage.header_text_PhucTho }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xatayphuong' }" @click="changeTab('Xatayphuong')">
  <a id="urlXatayphuong" href="vi/chuongtrinhtaitroxathidiem#hanoi/xatayphuong" style="color: white;">
    {{ currentLanguage.header_text_TayPhuong }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xaquocoai' }" @click="changeTab('Xaquocoai')">
  <a id="urlXaquocoai" href="vi/chuongtrinhtaitroxathidiem#hanoi/xaquocoai" style="color: white;">
    {{ currentLanguage.header_text_QuocOai }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xahungdao' }" @click="changeTab('Xahungdao')">
  <a id="urlXahungdao" href="vi/chuongtrinhtaitroxathidiem#hanoi/xahungdao" style="color: white;">
    {{ currentLanguage.header_text_HungDao }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xaankhanh' }" @click="changeTab('Xaankhanh')">
  <a id="urlXaankhanh" href="vi/chuongtrinhtaitroxathidiem#hanoi/xaankhanh" style="color: white;">
    {{ currentLanguage.header_text_AnKhanh }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xasondong' }" @click="changeTab('Xasondong')">
  <a id="urlXasondong" href="vi/chuongtrinhtaitroxathidiem#hanoi/xasondong" style="color: white;">
    {{ currentLanguage.header_text_SonDong }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xahoaiduc' }" @click="changeTab('Xahoaiduc')">
  <a id="urlXahoaiduc" href="vi/chuongtrinhtaitroxathidiem#hanoi/xahoaiduc" style="color: white;">
    {{ currentLanguage.header_text_HoaDuc }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xaodien' }" @click="changeTab('Xaodien')">
  <a id="urlXaodien" href="vi/chuongtrinhtaitroxathidiem#hanoi/xaodien" style="color: white;">
    {{ currentLanguage.header_text_ODien }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xamelinh' }" @click="changeTab('Xamelinh')">
  <a id="urlXamelinh" href="vi/chuongtrinhtaitroxathidiem#hanoi/xamelinh" style="color: white;">
    {{ currentLanguage.header_text_MeLinh }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xathienloc' }" @click="changeTab('Xathienloc')">
  <a id="urlXathienloc" href="vi/chuongtrinhtaitroxathidiem#hanoi/xathienloc" style="color: white;">
    {{ currentLanguage.header_text_LocThien }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xavinhthanh' }" @click="changeTab('Xavinhthanh')">
  <a id="urlXavinhthanh" href="vi/chuongtrinhtaitroxathidiem#hanoi/xavinhthanh" style="color: white;">
    {{ currentLanguage.header_text_VinhThanh }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xadonganh' }" @click="changeTab('Xadonganh')">
  <a id="urlXadonganh" href="vi/chuongtrinhtaitroxathidiem#hanoi/xadonganh" style="color: white;">
    {{ currentLanguage.header_text_DongAnh }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xaphudong' }" @click="changeTab('Xaphudong')">
  <a id="urlXaphudong" href="vi/chuongtrinhtaitroxathidiem#hanoi/xaphudong" style="color: white;">
    {{ currentLanguage.header_text_PhuDong }}
  </a>
</li>

<li :class="{ topmenuactive: activeTab === 'Xagialam' }" @click="changeTab('Xagialam')">
  <a id="urlXagialam" href="vi/chuongtrinhtaitroxathidiem#hanoi/xagialam" style="color: white;">
    {{ currentLanguage.header_text_GiaLam }}
  </a>
</li>

    </ul>
  </nav>

  <div class="wrapper row3">
      <main class="hoc container-fluid clear bv p-0">

      <!-- Mỗi xã -->
      <div v-if="activeTab === 'hethongcntthanoi'" style="min-height: 500px" class="padding-top15">
        <div class="title-bai-viet" v-html="titleHtmlHethongcntthanoi"></div>
        <div v-html="contentHtmlHethongcntthanoi || 'Đang cập nhật...'"></div>
        </div>
      <div v-if="showXathachthat" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXathachthat || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaphuctho" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXaphuctho || 'Đang cập nhật...'"></div></div>
      <div v-if="showXatayphuong" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXatayphuong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaquocoai" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXaquocoai || 'Đang cập nhật...'"></div></div>
      <div v-if="showXahungdao" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXahungdao || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaankhanh" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXaankhanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXasondong" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXasondong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXahoaiduc" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXahoaiduc || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaodien" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXaodien || 'Đang cập nhật...'"></div></div>
      <div v-if="showXamelinh" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXamelinh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXathienloc" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXathienloc || 'Đang cập nhật...'"></div></div>
      <div v-if="showXavinhthanh" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXavinhthanh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXadonganh" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXadonganh || 'Đang cập nhật...'"></div></div>
      <div v-if="showXaphudong" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXaphudong || 'Đang cập nhật...'"></div></div>
      <div v-if="showXagialam" class="padding-top15"><strong>&nbsp;</strong><div v-html="contentHtmlXagialam || 'Đang cập nhật...'"></div></div>
    </main>
  </div>
</template>
<script scoped>
import { languages } from "@/components/languages";
import { apiChiTietBaiViet } from "@/components/listService";
import axios from "axios";


export default {
  components: {

  },
  data() {
    return {
      activeTab: 'hethongcntthanoi',

      currentLanguage: languages.vi,
      lang: "",
      base64: "",
      base64Title: "",

      showXatayphuong: false,
      showXaquocoai: false,
      showXaphuctho: false,
      showCopilot: false,
      showGrok: false,
      showXahungdao: false,
      showManus: false,
      showXathachthat: false,
      showXaankhanh: false,
      showXasondong: false,
      showUngDungAI: false,
      showXahoaiduc: false,
      showXaodien: false,
      showXamelinh: false,
      showXathienloc: false,
      showXavinhthanh: false,
      showXadonganh: false,
      showXaphudong: false,
      showXagialam: false,
      showHethongcntthanoi: false,

      titleHtmlAITaiLopHoc: "",
      contentHtmlAITaiLopHoc: "",
      titleHtml: "",
      contentHtml: "",
      titleHtmlTruongTaiTro: "",
      contentHtmlTruongTaiTro: "",
      titleHtmlTH: "",
      contentHtmlTH: "",
      titleHtmlTHCS: "",
      contentHtmlTHCS: "",
      titleHtmlTHPT: "",
      contentHtmlTHPT: "",
      titleHtmlLienHe: "",
      contentHtmlLienHe: "",
      titleHtmlLienCap: "",
      contentHtmlLienCap: "",

      titleHtmlXathachthat: "",
      titleHtmlXatayphuong: "",
      titleHtmlXaquocoai: "",
      titleHtmlXaphuctho: "",
      titleHtmlCopilot: "",
      titleHtmlGrok: "",
      titleHtmlXahungdao: "",
      titleHtmlXaankhanh: "",
      titleHtmlXasondong: "",
      titleHtmlManus: "",
      titleHtmlUngDungAI: "",
      titleHtmlXahoaiduc: "",
      titleHtmlXaodien: "",
      titleHtmlXamelinh: "",
      titleHtmlXathienloc: "",
      titleHtmlXavinhthanh: "",
      titleHtmlXadonganh: "",
      titleHtmlXaphudong: "",
      titleHtmlXagialam: "",
titleHtmlHethongcntthanoi: "",
conttentHtmlHethongcntthanoi: "",

      contentHtmlXathachthat: "",
      contentHtmlXatayphuong: "",
      contentHtmlXaquocoai: "",
      contentHtmlCopilot: "",
      contentHtmlXaphuctho: "",
      contentHtmlGrok: "",
      contentHtmlXahungdao: "",
      contentHtmlXaankhanh: "",
      contentHtmlXasondong: "",
      contentHtmlManus: "",
      contentHtmlUngDungAI: "",
      contentHtmlXahoaiduc: "",

      contentHtmlXaodien: "",
      contentHtmlXamelinh: "",
      contentHtmlXathienloc: "",
      contentHtmlXavinhthanh: "",
      contentHtmlXadonganh: "",
      contentHtmlXaphudong: "",
      contentHtmlXagialam: "",


    };
  },
  mounted() {
    if (window.innerWidth <= 768) {
      this.isMenuVisible = false;
    } else {
      this.isMenuVisible = true;
    }
    if (!this.hasMounted) {
      this.hasMounted = true;
      this.lang = localStorage.getItem("languages")   || "vi";
      // this.performPostRequest("1755075075179y5bWE", "Xatayphuong", this.lang);
document.getElementById("urlhethongcntthanoi").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/hethongcntt");
      document.getElementById("urlXathachthat").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xathachthat");
      document.getElementById("urlXaphuctho").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xaphuctho");
      document.getElementById("urlXaquocoai").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xaquocoai");
      document.getElementById("urlXatayphuong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xatayphuong");
      document.getElementById("urlXahungdao").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xahungdao");
      document.getElementById("urlXaankhanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xaankhanh");
      document.getElementById("urlXasondong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xasondong");
      document.getElementById("urlXahoaiduc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xahoaiduc");
      document.getElementById("urlXaodien").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xaodien");
      document.getElementById("urlXamelinh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xamelinh");
      document.getElementById("urlXathienloc").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xathienloc");
      document.getElementById("urlXavinhthanh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xavinhthanh");
      document.getElementById("urlXadonganh").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xadonganh");
      document.getElementById("urlXaphudong").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xaphudong");
      document.getElementById("urlXagialam").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/xagialam");


      // document.getElementById("urlManus").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/manus/");
      // document.getElementById("urlGrok").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/grok/");
      // document.getElementById("urlCopilot").setAttribute("href", this.lang + "/chuongtrinhtaitroxathidiem#hanoi/copilot/");




      let fragmentTab = window.location.hash.substring(1);
            if (fragmentTab.endsWith("/")) {
                fragmentTab = fragmentTab.slice(0, -1);
            }
      console.log("fragmentTab " + fragmentTab);

      if (fragmentTab === "hanoi/xathachthat") {
        this.changeTab("Xathachthat");
      } else if (fragmentTab === "hanoi/xaphuctho") {
        this.changeTab("Xaphuctho");
      } else if (fragmentTab === "hanoi/xaquocoai") {
        this.changeTab("Xaquocoai");
      } else if (fragmentTab === "hanoi/xatayphuong") {
        this.changeTab("Xatayphuong");
      } else if (fragmentTab === "hanoi/copilot") {
        this.changeTab("Copilot");
      } else if (fragmentTab === "hanoi/grok") {
        this.changeTab("Grok");
      } else if (fragmentTab === "hanoi/xahungdao") {
        this.changeTab("Xahungdao");
      } else if (fragmentTab === "hanoi/manus") {
        this.changeTab("Manus");
      } else if (fragmentTab === "hanoi/xaankhanh") {
        this.changeTab("Xaankhanh");
      }   else if (fragmentTab === "hanoi/xasondong") {
        this.changeTab("Xasondong");
      } else if (fragmentTab === "hanoi/xahoaiduc") {
        this.changeTab("Xahoaiduc");
      } else if (fragmentTab === "hanoi/xaodien") {
        this.changeTab("Xaodien");
      } else if (fragmentTab === "hanoi/xamelinh") {
        this.changeTab("Xamelinh");
      } else if (fragmentTab === "hanoi/xathienloc") {
        this.changeTab("Xathienloc");
      } else if (fragmentTab === "hanoi/xavinhthanh") {
        this.changeTab("Xavinhthanh");
      } else if (fragmentTab === "hanoi/xadonganh") {
        this.changeTab("Xadonganh");
      } else if (fragmentTab === "hanoi/xaphudong") {
        this.changeTab("Xaphudong");
      } else if (fragmentTab === "hanoi/xagialam") {
        this.changeTab("Xagialam");
      }
else if (fragmentTab === "hanoi/hethongcntthanoi") {
        this.changeTab("hethongcntthanoi");
}
       else {
        // Nếu không phù hợp với bất kỳ tab nào, mặc định hiển thị tab gioiThieu
        this.changeTab("hethongcntthanoi");
      }
    }
  },
  created() {
    const savedLanguage = localStorage.getItem("languages");
    if (savedLanguage && languages[savedLanguage]) {
      this.currentLanguage = languages[savedLanguage];
    }
  },
  methods: {
    changeLanguage(lang) {
      this.currentLanguage = languages[lang];
      localStorage.setItem("languages", lang);
      window.location.reload();
    },

    async performPostRequest(id, section) {
      this.lang = localStorage.getItem("languages") || "vi";

      try {
        // Thực hiện POST request
        const response = await axios.post(apiChiTietBaiViet, {
          id: id,
          langId: "0",
        });
        if (this.lang === "vi") {
          this.base64 = response.data.result.content_vi;
          this.base64Title = response.data.result.title_vi;
        } else if (this.lang === "en") {
          this.base64 = response.data.result.content_en;
          this.base64Title = response.data.result.title_en;
        } else if (this.lang === "cn") {
          this.base64 = response.data.result.content_cn;
          this.base64Title = response.data.result.title_cn;
        } else if (this.lang === "kr") {
          this.base64 = response.data.result.content_kr;
          this.base64Title = response.data.result.title_kr;
        }

        var title = atob(this.base64Title);
        var decodedString = atob(this.base64);

        // Store separately for each section
        if (section === "Xatayphuong") {
          this.titleHtmlXatayphuong = decodeURIComponent(escape(title));
          this.contentHtmlXatayphuong = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaquocoai") {
          this.titleHtmlXaquocoai = decodeURIComponent(escape(title));
          this.contentHtmlXaquocoai = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphuctho") {
          this.titleHtmlXaphuctho = decodeURIComponent(escape(title));
          this.contentHtmlXaphuctho = decodeURIComponent(escape(decodedString));
        } else if (section === "Copilot") {
          this.titleHtmlCopilot = decodeURIComponent(escape(title));
          this.contentHtmlCopilot = decodeURIComponent(escape(decodedString));
        } else if (section === "Grok") {
          this.titleHtmlGrok = decodeURIComponent(escape(title));
          this.contentHtmlGrok = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahungdao") {
          this.titleHtmlXahungdao = decodeURIComponent(escape(title));
          this.contentHtmlXahungdao = decodeURIComponent(escape(decodedString));
        } else if (section === "Manus") {
          this.titleHtmlManus = decodeURIComponent(escape(title));
          this.contentHtmlManus = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathachthat") {
          this.titleHtmlXathachthat = decodeURIComponent(escape(title));
          this.contentHtmlXathachthat = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xaankhanh") {
          this.titleHtmlXaankhanh = decodeURIComponent(escape(title));
          this.contentHtmlXaankhanh = decodeURIComponent(escape(decodedString));
        }
        else if (section === "Xasondong") {
          this.titleHtmlXasondong = decodeURIComponent(escape(title));
          this.contentHtmlXasondong = decodeURIComponent(escape(decodedString));
        }else if (section === "UngDungAI") {
          this.titleHtmlUngDungAI = decodeURIComponent(escape(title));
          this.contentHtmlUngDungAI = decodeURIComponent(escape(decodedString));
        } else if (section === "Xahoaiduc") {
          this.titleHtmlXahoaiduc = decodeURIComponent(escape(title));
          this.contentHtmlXahoaiduc = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaodien") {
          this.titleHtmlXaodien = decodeURIComponent(escape(title));
          this.contentHtmlXaodien = decodeURIComponent(escape(decodedString));
        } else if (section === "Xamelinh") {
          this.titleHtmlXamelinh = decodeURIComponent(escape(title));
          this.contentHtmlXamelinh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xathienloc") {
          this.titleHtmlXathienloc = decodeURIComponent(escape(title));
          this.contentHtmlXathienloc = decodeURIComponent(escape(decodedString));
        } else if (section === "Xavinhthanh") {
          this.titleHtmlXavinhthanh = decodeURIComponent(escape(title));
          this.contentHtmlXavinhthanh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xadonganh") {
          this.titleHtmlXadonganh = decodeURIComponent(escape(title));
          this.contentHtmlXadonganh = decodeURIComponent(escape(decodedString));
        } else if (section === "Xaphudong") {
          this.titleHtmlXaphudong = decodeURIComponent(escape(title));
          this.contentHtmlXaphudong = decodeURIComponent(escape(decodedString));
        } else if (section === "Xagialam") {
          this.titleHtmlXagialam = decodeURIComponent(escape(title));
          this.contentHtmlXagialam = decodeURIComponent(escape(decodedString));
        }else if (section === "hethongcntthanoi") {
          this.titleHtmlHethongcntthanoi = decodeURIComponent(escape(title));
          this.contentHtmlHethongcntthanoi = decodeURIComponent(escape(decodedString));
       
        }
      } catch (error) {
        console.error("Error:", error);
      }
    },
    changeTab(tab) {
      //   if (window.innerWidth <= 768) {
      //     this.isMenuVisible = false;
      //   }
      this.lang = localStorage.getItem("languages");

      const tabStates = {

        Xatayphuong: false, Xaquocoai: false, Xaphuctho: false, Copilot: false, ungDungAI: false,
        Xathachthat: false, xahungdao: false, Grok: false, Manus: false, Xaankhanh: false, Xasondong: false,
        Xahoaiduc: false, Xaodien: false, Xamelinh: false, Xathienloc: false, Xavinhthanh: false, Xadonganh: false, Xaphudong: false, Xagialam: false,
        hethongcntthanoi: false,
      };

      this.performPostRequest(this.getPostId(tab), tab, this.lang);

      tabStates[tab] = true;
      this.activeTab = tab;
      this.showXatayphuong = tabStates.Xatayphuong;
      this.showXaquocoai = tabStates.Xaquocoai;
      this.showXaphuctho = tabStates.Xaphuctho;
      this.showCopilot = tabStates.Copilot;
      this.showGrok = tabStates.Grok;
      this.showXahungdao = tabStates.Xahungdao;
      this.showManus = tabStates.Manus;
      this.showXathachthat = tabStates.Xathachthat;
      this.showXaankhanh = tabStates.Xaankhanh;
      this.showXasondong = tabStates.Xasondong;
      this.showUngDungAI = tabStates.UngDungAI;
      this.showXahoaiduc = tabStates.Xahoaiduc;
      this.showXaodien = tabStates.Xaodien;
      this.showXamelinh = tabStates.Xamelinh;
      this.showXathienloc = tabStates.Xathienloc;
      this.showXavinhthanh = tabStates.Xavinhthanh;
      this.showXadonganh = tabStates.Xadonganh;
      this.showXaphudong = tabStates.Xaphudong;

      this.showXagialam = tabStates.Xagialam;
      this.showHethongcntthanoi = tabStates.hethongcntthanoi;

    },
    getPostId(tab) {
      // Sử dụng một đối tượng để ánh xạ tab với id của bài viết tương ứng
      const postIdMap = {

        Xatayphuong: "1758346506251WDrNU",
        Xaquocoai: "1758346547504VdtuA",
        Xaphuctho: "1758346450606csozc",
        Copilot: "",
        Grok: "",
        Xahungdao: "17583465971745uGoL",
        Manus: "",
        Xathachthat: "1758179541427wYwnq",
        Xaankhanh: "1758273128114Q5sLd", 
        Xasondong: "1758346637846HaotP",     
        UngDungAI: "",  
        Xahoaiduc: "1758346676890EHdLL",   
        Xaodien: "1758346755937aBsQW", 
        Xamelinh: "1758346792802zTWjG",  
        Xathienloc: "1758275977035uwGPY", 
        Xavinhthanh: "1758346827413BPng3",    
        Xadonganh: "1758346861767ji2rO",    
        Xaphudong: "1758346896487A6f56",   
        Xagialam: "1758343521054Rfxnw",    
        hethongcntthanoi: "1757580776972edaks", 
      };

      return postIdMap[tab];
    },
  },
};
</script>

<style scoped>
.title-bai-viet {
  display: none;
}

.hiddentitle {
  display: none;
}
</style>
